import { Box, BoxProps, convertHexToRGBA, IconButton, Spacer, Text, TextProps } from '@jfs/ui-new'
import React from 'react'
import { Dimensions } from 'react-native'
import { Modal } from '../../../comps/Modal'
import { OtpTextInputWithTimer } from '../../../comps/OtpTextInputWithTimer'
import { MerchantTheme } from '../../../data/models/Config'
import { ActionButton } from './ActionButton'

interface VerifyOTPModelProps {
  show: boolean
  onDismiss: () => void
  onOTPSubmit: (otp: string) => void
  isLoading?: boolean
  theme: any
  mobileNo: string
  onResendOtpButtonPress: () => void
  isResendOtpLoading: boolean
}

export const VerifyOTPModel = ({
  show,
  onDismiss,
  onOTPSubmit,
  isLoading,
  theme,
  mobileNo,
  onResendOtpButtonPress,
  isResendOtpLoading,
}: VerifyOTPModelProps) => {
  const [otp, setOtp] = React.useState('')
  const isLargeScreen = Dimensions.get('window').width > 550
  const isFullScreen =
    window.location.href.includes('/pg/loader.html') || window.location.href.includes('/pg/redirectToBank')

  if (!show) {
    return null
  }

  return (
    <Modal type="Bottom" show={show} isFullWidth={true} headerType="White_Bg" onDismiss={onDismiss} theme={theme}>
      <Box {...styles.container(isLargeScreen && !isFullScreen, theme)}>
        <Box {...styles.headerContainer}>
          <Text {...styles.headerTitle(theme)}>Verify OTP</Text>
          <IconButton
            id={'CLOSE'}
            testID="close-modal"
            onPress={onDismiss}
            color={convertHexToRGBA(theme.bodyTextColor, 40) as any}
          />
        </Box>

        <Text {...styles.title(theme)}>A One Time Password (OTP) has been sent to your mobile number</Text>
        <Spacer size={6} />
        <Text {...styles.title(theme)} color={theme.bodyTextColor}>
          {'+91 ' + mobileNo}
        </Text>
        <Spacer size={18} />
        <OtpTextInputWithTimer
          value={otp}
          onChangeText={setOtp}
          onResendOtpButtonPress={onResendOtpButtonPress}
          isLoading={isResendOtpLoading}
          isResendOtpLoading={false}
        />

        <Spacer size={48} />
        <ActionButton
          title={'Check Eligibility'}
          onPress={() => onOTPSubmit(otp)}
          isLoading={isLoading}
          disabled={otp.length !== 6}
        />
      </Box>
    </Modal>
  )
}

const styles = {
  container: (isLargeScreen: boolean, theme: typeof MerchantTheme.properties) =>
  ({
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: isLargeScreen ? 16 : undefined,
    borderBottomRightRadius: isLargeScreen ? 16 : undefined,
    backgroundColor: theme.bodyBgColor as any,
    p: 24,
  } as BoxProps),
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 32,
  } as BoxProps,
  headerTitle: (theme: typeof MerchantTheme.properties) =>
  ({
    fontSize: 16,
    fontFamily: 'jioType-medium',
    color: theme.bodyTextColor as any,
  } as TextProps),
  title: (theme: typeof MerchantTheme.properties) =>
  ({
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: convertHexToRGBA(theme.bodyTextColor, 50),
    lineHeight: 20,
  } as TextProps),
}
